import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/salesContent';
import { trackInitiateCheckout } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  note?: string;
  pulse?: boolean;
};
export function CtaButton({
  children,
  note,
  pulse = true
}: CtaButtonProps) {
  const reduceMotion = useReducedMotion();
  const shouldPulse = pulse && !reduceMotion;
  return <div className="flex w-full flex-col items-center" data-id="element-25" data-mp="llqv76kplu22">
      <motion.a href={CHECKOUT_URL} onClick={trackInitiateCheckout} animate={shouldPulse ? {
      scale: [1, 1.025, 1]
    } : undefined} transition={shouldPulse ? {
      duration: 2.4,
      ease: 'easeInOut',
      repeat: Infinity
    } : undefined} className="group inline-flex w-full max-w-2xl items-center justify-center gap-3 rounded-lg border-b-4 border-accent-700 bg-accent-500 px-5 py-4 text-center font-display text-lg font-extrabold uppercase tracking-wide text-carbon-950 shadow-lg shadow-black/50 transition-colors duration-150 ease-out hover:bg-accent-400 focus:outline-none focus-visible:ring-4 focus-visible:ring-accent-400/50 md:py-5 md:text-xl" data-id="element-26" data-mp="ll7bbkbi0vle">
        <span data-id="element-27" data-mp="3ewsw3v4thlsw">{children}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-28" data-mp="3ewja0imw7ysh" />
      </motion.a>
      {note && <p className="mt-3 text-center text-sm font-medium text-carbon-400" data-id="element-29" data-mp="3ouz1wntqvc31">{note}</p>}
    </div>;
}